import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import AppLandingPage from './containers/App';
import { setConfigInfo, setUserInfo, setSourceType } from './redux/actions/genericActions';
import { store } from './redux/store';

export class MasterCardAlerts extends Component {
  constructor(props) {
    super(props);
    store.dispatch(setConfigInfo(props.configValues));
    store.dispatch(setUserInfo(props.userInfo));
    store.dispatch(setSourceType(props.source));
  }
  render() {
    const { masterCardAlertBack, masterCardLeavePopup, source } = this.props;
    return (
      <Provider store={store}>
        <AppLandingPage
          masterCardAlertBack={masterCardAlertBack}
          masterCardLeavePopup={masterCardLeavePopup}
          source={source}
        />
      </Provider>
    );
  }
}

MasterCardAlerts.propTypes = {
  source: PropTypes.string.isRequired,
  configValues: PropTypes.shape({
    brandId: PropTypes.string.isRequired,
  }),
  userInfo: PropTypes.shape({}),
  masterCardAlertBack: PropTypes.func,
  masterCardLeavePopup: PropTypes.func,
};
